import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import ExportYearlyBalanceModal from 'modules/shift_management/components/ShiftManagement/ExportYearlyBalanceModal'

const ExportYearlyBalanceModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { periodType, year, month, day } = useStrictParams<
    'periodType' | 'year' | 'month' | 'day'
  >()

  const onClose = () => {
    navigate(
      navigation.timeTracking.list.periodTypeYearMonthDay.fullPath({
        periodType,
        year,
        month,
        day,
      })
    )
  }

  return <ExportYearlyBalanceModal onClose={onClose} from="time-tracking" />
}

export default ExportYearlyBalanceModalPage
